function ArticleLoader({ length }: { length: number }) {
  return (
    <div>
      {Array.from({ length: length }).map((_, index) => (
        <div className="flex items-center gap-2" key={index}>
          <div className="mb-2 h-12 w-12 animate-pulse rounded-lg bg-gray-400" />
          <div>
            <div className="mb-2 h-4 w-40 animate-pulse rounded-md bg-gray-400" />
            <div className="mb-2 h-4 w-72 animate-pulse rounded-md bg-gray-400" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default ArticleLoader;
